export default __webpack_public_path__ + "static/media/08_FadeIn.91fe594d.mp4";